// Steps are always selected in full. `stepNumber` is part of the selection on
// purpose: the form relies on it to restore the authored ORDER, and a selection
// that omitted it would silently render the steps in whatever order the store
// returned them.
const TEST_DEFINITION_FIELDS = `
    id
    testCode
    name
    description
    applicationId
    steps {
      stepNumber
      actionCode
      inputs {
        key
        value
      }
      expect
    }
    status
    createdByUsername
    updatedByUsername
    created
    updated
`;

export const listTestDefinitions = `
   query listTestDefinitions($filter: TestDefinitionsFilterInput, $limit: Int, $nextToken: String) {
       listTestDefinitions(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              ${TEST_DEFINITION_FIELDS}
           }
           nextToken
       }
   }
`;

export const getTestDefinition = `
   query getTestDefinition($id: ID!) {
       getTestDefinition(id: $id) {
         ${TEST_DEFINITION_FIELDS}
       }
}`;
